<template>
  <div class="control-top-container">
    <div class="control-container-outer">
      <div class="control-cotainer">
        <button class="control-item camera" :class="{active: me.cameraStatus === 'on', inactive: me.cameraStatus === 'off', notExist: me.cameraStatus === undefined}" @click="onToggleUserDeviceStatus">{{ $t(`camstudy.control.camera.${me.cameraStatus === 'on' ? 'off' : 'on'}`) }}</button>
        <button class="control-item setting" @click="onToggleDeviceSettingModal">{{ $t('camstudy.control.screenSetting') }}</button>
        <button class="control-item participant"
                :data-usercnt="roomUserCount"
                @click="onToggleParticipantModal"
        >{{ $t('camstudy.control.participants') }}</button>
        <button class="control-item more" :class="{alert: isExistsUnReadChat}" @click="onMoreControl">{{ $t('camstudy.control.more') }}</button>
        <button class="control-item go-out" @click="exitRoom">{{ $t('camstudy.control.exit') }}</button>
      </div>
    </div>
    <ControlMoreModal v-show="isOpenMoreControl" @onCloseMoreModal="onCloseMoreModal" />
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {closeWindow} from "@/core/api/util.api";
import CamstudyDeviceSettingModal from "@/components/Room/DeviceSetting/coordi/Modal.vue";
import CamstudyParticipantModal from "@/components/Room/Camstudy/control/Participant.vue"
import ControlMoreModal from "@/components/Room/Camstudy/control/ControlMoreModal.vue"

export default {
  name: 'CamstudyControl',
  components: {ControlMoreModal},
  props: {
    v2CamsHomeUrl: String,
    isOpenControlMenu: Boolean,
  },
  data(){
    return {
      isOpenMoreControl: false
    }
  },
  computed:{
    ...mapGetters('user', [
      'me',
      'roomUserCount'
    ]),
    ...mapGetters('room', [
      'room',
    ]),
    ...mapGetters('chat', [
        'isExistsUnReadChat'
    ])
  },
  watch: {
    isOpenControlMenu(){
      if(this.isOpenControlMenu){
        return;
      }
      if(this.isOpenMoreControl){
        this.isOpenMoreControl = false;
      }
      [
        'CamstudyDeviceSettingModal',
        'CamstudyParticipantModal',
        'CamstudyAttendanceModal',
        'CamstudyRoomSettingModal',
        'CamstudyWhiteNoiseModal',
        'CamstudyBlockMemberModal',
        'CamstudyChatModal',
        'CamstudyMySettingModal',
      ].forEach(item => {
        if(this.$isOpenedModal(item)){
          this.$modal(item)
        }
      })
    }
  },
  methods: {
    ...mapActions('user', [
      'toggleUserDeviceStatus'
    ]),
    ...mapActions('room', [
      'reqLeave'
    ]),
    isEnableDevice(){
      return (deviceType) => {
        if(!deviceType) return;

        const {roomUserRole} = this.me;
        if(!roomUserRole) return;

        return roomUserRole[deviceType];
      }
    },
    onToggleUserDeviceStatus(){
      if(this.isEnableDevice('camera')){
        this.toggleUserDeviceStatus({deviceType: 'camera'})
      }
    },
    exitRoom() {
      this.$camsAlert({
        title: this.$t('menu.quit.title'),
        text: this.hasWaitingUser && this.hasEmceeRole() ? this.$t('menu.quit.hasWaitingUser') : this.$t('menu.quit.text'),
        okText: this.$t('menu.quit.title'),
        ok: () => {
          this.reqLeave();
          localStorage.removeItem('grm_camstudy_pin');

          if (this.room.isMobileCamStudy) {
            window.location.href = this.v2CamsHomeUrl;
          } else {
            closeWindow();
          }
        }
      })
    },
    onToggleDeviceSettingModal() {
      this.$modal(CamstudyDeviceSettingModal, {once: true}, this.onCloseMoreModal)
    },
    onToggleParticipantModal(){
      this.$modal(CamstudyParticipantModal, {once: true, fade: false, fadeOpacity: true}, this.onCloseMoreModal)
    },
    onMoreControl(){
      [
        'CamstudyDeviceSettingModal',
        'CamstudyParticipantModal',
        'CamstudyAttendanceModal',
        'CamstudyRoomSettingModal',
        'CamstudyWhiteNoiseModal',
        'CamstudyBlockMemberModal',
        'CamstudyChatModal',
        'CamstudyMySettingModal',
      ].forEach(item => {
        if(this.$isOpenedModal(item)){
          this.$modal(item)
        }
      })
      this.isOpenMoreControl = !this.isOpenMoreControl;
    },
    onCloseMoreModal(){
      this.isOpenMoreControl = false;
    }
  }
}
</script>

<style scoped lang="scss">
[grm-device-mobile]{
}
html:not([grm-device-mobile]){
  .control-top-container{
    .control-container-outer {
      position: static;
      display: flex;
      justify-content: center;
      padding: 8px;
      height: 80px;

      .control-cotainer {
        width: 100%;
        gap: 24px;
        justify-content: center;

        .control-item{
          width: 64px;
          border-radius: 12px;
        }
      }
    }
  }
}
.control-top-container.visible > .control-container-outer{
    transform: translateY(0);
    opacity: 1;
}
.control-top-container:not(.visible) > .control-container-outer{
    transform: translateY(100%);
    opacity: 0;
}
.control-container-outer {
  transition: transform 0.3s ease-out, opacity 0.3s ease-out;
  position: absolute;
  .control-cotainer {
    display: flex;
    gap: 4px;
    transition: opacity 0.3s ease-out;
  }
  background: #141414;
  color: white;
  scrollbar-width: none;
  z-index: 101;

  &::-webkit-scrollbar {
    display: none;
  }

  @media(orientation: portrait){
    height: 64px;
    width: 100%;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0 20px;

    .control-item{
      width: 100%;
      height: 63px;
      background-position: top 10px left;
    }
  }
  @media(orientation: landscape){
    padding: 0 10px 34px 10px;
    left: env(safe-area-inset-left);
    right: env(safe-area-inset-right);
    bottom: 0;
    .control-item {
      width: 100%;
      height: 64px;
      background-position: top 10px center;
    }
  }

  .control-item {
    padding: 40px 0 10px;
    font-size: 11px;
    line-height: 100%;
    text-align: center;
    background-repeat: no-repeat;

    &.camera{
      &.active {
        background-image: url('~@/assets/images/camstudy/control_camera.svg');
        background-position: top 10px center;
      }
      &.inactive {
        background-image: url('~@/assets/images/camstudy/control_camera_inactive.svg');
        background-position: top 10px center;
      }
      &.notExist {
        background-image: url('~@/assets/images/camstudy/control_camera_notExist.svg');
        background-position: top 10px center;
      }
    }

    &.setting{
      background-image: url('~@/assets/images/camstudy/control_device_setting.svg');
      background-position: center top 8px;
    }

    &.participant{
      background-image: url('~@/assets/images/camstudy/control_participant.svg');
      background-position: center top 10.5px;
      position: relative;

      &:before {
        content: attr(data-usercnt);
        position: absolute;
        left: 52%;
        top: 6px;
        min-width: 16px;
        padding: 0 4px;
        border-radius: 10px;
        background: #016FF2;
        color: #FFF;
        font-size: 10px;
        font-weight: bold;
        line-height: 16px;
      }
    }
    &.more{
      position: relative;
      background-image: url('~@/assets/images/camstudy/control_more.svg');
      background-position: top 10px center;

      &.alert{
        &::before {
          content: '';
          position: absolute;
          top: 5px;
          right: 12px;
          transform: translate(-50%, 50%);
          width: 5px;
          height: 5px;
          background: #016FF2;
          border-radius: 50%;
        }
      }
    }
    &.go-out{
      background-position: top 10px center;
      background-image: url('~@/assets/images/camstudy/control_out.svg');
    }

    &:focus{
      background-color: #FFFFFF1A;
    }
  }
}
//.more-modal{
//  position: fixed;
//  bottom: 72px;
//  left: 8px;
//  border-radius: 12px;
//  background: #313131;
//  padding: 12px 0;
//  width: calc(100% - 16px);
//
//  .more-item{
//    padding: 12px 18px 12px 54px;
//    color: white;
//    font-size: 14px;
//
//    &.attendance{
//      background: url('~@/assets/images/camstudy/ico_partcipant_white.svg') no-repeat center left 18px;
//    }
//    &.study-setting{
//      background: url('~@/assets/images/camstudy/ico_study_setting_white.svg') no-repeat center left 18px;
//    }
//    &.white-noise{
//      background: url('~@/assets/images/camstudy/ico_white_noise_white.svg') no-repeat center left 18px;
//    }
//    &.block{
//      background: url('~@/assets/images/camstudy/ico_block_member_white.svg') no-repeat center left 18px;
//    }
//  }
//}
</style>